import React, { useId, useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import './PasswordFieldToggle.css';

/**
 * Password input with show/hide control (login, signup, Front Desk forms).
 */
export function PasswordFieldToggle({
  id: idProp,
  label,
  labelClassName,
  value,
  onChange,
  name,
  autoComplete,
  required,
  minLength,
  placeholder,
  inputClassName = '',
  errorText,
  errorClassName = 'login-field-error',
}) {
  const autoId = useId();
  const id = idProp || `pwd-${autoId}`;
  const [visible, setVisible] = useState(false);

  return (
    <div className="lux-password-wrap">
      {label ? (
        <label className={labelClassName || 'login-label'} htmlFor={id}>
          {label}
        </label>
      ) : null}
      <div className="lux-password-field">
        <input
          id={id}
          name={name}
          type={visible ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          required={required}
          minLength={minLength}
          placeholder={placeholder}
          className={inputClassName}
        />
        <button
          type="button"
          className="lux-password-toggle"
          tabIndex={-1}
          aria-label={visible ? 'Hide password' : 'Show password'}
          onClick={() => setVisible((v) => !v)}
        >
          {visible ? <FiEyeOff size={18} aria-hidden /> : <FiEye size={18} aria-hidden />}
        </button>
      </div>
      {errorText ? <small className={errorClassName}>{errorText}</small> : null}
    </div>
  );
}
